import { AxiosRequestConfig } from "axios";
import ApiConstants from "../constants/ApiConstants";
import http from "../http";
import moment from 'moment'
import { FORMAT } from "../constants/Constant";


export interface OvertimePolicyConfig  {
    limit: number,
    currentPage: number,
    from: string,
    to: string
}
const defaultConfig = {
    limit: 20,
    currentPage: 1
}
export default class OvertimeApiService {
    static OTConfig = defaultConfig;
    static getOvertimePolicy(param) {
        if(!param) {
            OvertimeApiService.OTConfig = defaultConfig;
            param = defaultConfig;
        }
        const url = ApiConstants.URL.OVERTIME.OVERTIME_POLICY;
        return http.get(url,{params:param});
    }
    static getOvertimePolicyById(id) {
        const url = ApiConstants.URL.OVERTIME.OVERTIME_POLICY_BY_ID(id);
        return http.get(url);
    }
    static saveOvertimePolicy(param, isUpdate) {
        const url = ApiConstants.URL.OVERTIME.OVERTIME_POLICY;
        if(isUpdate) {
            return http.patch(url,param);
        } else {
            return http.post(url,param);
        }
    }
    static delete(param) {
        const url = `${ApiConstants.URL.OVERTIME.OVERTIME_POLICY}/delete`;
        return http.post(url,param);
    }

    static getOvertimeMultiplier() {
        const url = ApiConstants.URL.OVERTIME.OVERTIME_MULTIPLIER;
        return http.get(url);
    }
    static saveOvertimeMultiplier(param) {
        const url = ApiConstants.URL.OVERTIME.OVERTIME_MULTIPLIER;
        return http.patch(url,param);
    }
    static getOvertimeByEmployee(param) {
        const url = ApiConstants.URL.OVERTIME.OVERTIME_FIND;
        return http.post(url,param);
    }
}